export default function composeParams(state, data) {
  const params = {}
  const limit = typeof data.limit === 'number' ? data.limit : 16
  const page = data.page || 1
  let sortDir = data.sortDir || -1
  let sortBy = data.sortBy



  // catalogueRelevance is a frontend-only sort - use default itemId sort for backend
  if (sortBy === 'catalogueRelevance') {
    sortBy = 'itemId.keyword'
    sortDir = -1
  } else if (sortBy && sortBy.startsWith('-')) {
    sortDir = 1
    sortBy = sortBy.replace('-', '')
  }

  params.$limit = limit
  params.$skip = (page - 1) * limit

  if (data.category) {
    if (Array.isArray(data.category)) {
      params['class.internalId[$in]'] = data.category
    } else {
      params['class.internalId[$match]'] = data.category
    }
  }

  if (data.connections) {
    let connections = []

    // iterate over the types of connection that we could have (e.g. netsuite category/tag/collection)
    for (const key in data.connections) {
      // get the ids of the items relating to that connection (ie the netsuite category id)
      let connectionIds = data.connections[key]
      if (connectionIds.length === 1) {
        connectionIds = connectionIds[0]
      }

      // // set the selector to match a single value
      // let selector = '$match'
      // // if we have an array of IDs then set the selector to match many values
      // if (Array.isArray(connectionIds)) {
      //   selector = '$in'
      // }
      //
      // // create the param using the key and the selector with the connection Ids as values
      // // this will query for the internal id of the connection type on an item
      // params[`${key}.internalId[${selector}]`] = connectionIds

      connections.push({
        key: key,
        connectionIds: connectionIds
      })
    }

    params['connections'] = { values: connections }
  }

  if(data.menuItemId){
    params.menuItemId = data.menuItemId
  }

  params.includePricing = data.includePricing
  params.visibleInCatalogue = true
  params.scope = data.scope
  params.en = data.en
  params.colour = data.colour
  params.ideal = data.ideal
  params.q = data.q
  params.catalogue = data.catalogue
  params.catId = data.catid 
  params[`$sort[${sortBy}]`] = sortBy ? sortDir : null

  if (data.includeChildren) {
    params.includeChildren = true
  }

  if(data.catalogueId){
    params.catalogueId = data.catalogueId
  }

  if (data.includeFinished) {
    params.includeFinished = true
  }

  if (data.consolidateToBase) {
    params.consolidateToBase = true
  }

  if (data.includeBudget) {
    params.includeBudget = true
  }

  return params
}
